export const ONBOARDING_TITLE_LINE_1 = 'Browse for 1 minute,';
export const ONBOARDING_TITLE_LINE_2 = 'Earn 10 points!';

export const ONBOARDING_HOW_IT_WORKS = 'How it works';

export const ONBOARDING_BULLETS = [
  'Get rewarded every minute you browse',
  'Earn points multiple times a day',
  'Keep exploring to earn more',
] as const;

export const ONBOARDING_NOTE_TITLE = 'PLEASE NOTE';

export const ONBOARDING_NOTE_BULLETS = [
  'Points are earned once per browsing session',
  'Session resets after a period of inactivity',
] as const;

export const ONBOARDING_CTA_TEXT = 'Keep browsing & earn points';
